import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Fuel, Cog, Gauge } from "lucide-react";
import { fileUrl, formatPrice } from "../lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1200&auto=format&fit=crop";

const CarCard = ({ car, index = 0 }) => {
  const img = car.images && car.images.length > 0 ? fileUrl(car.images[0]) : FALLBACK;

  return (
    <Link
      to={`/araba/${car.id}`}
      data-testid={`car-card-${car.id}`}
      className="group block bg-zinc-950 border border-zinc-900 hover:border-orange-600/60 transition-colors duration-300 overflow-hidden anim-slide-up"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-900">
        <img
          src={img}
          alt={`${car.brand} ${car.model}`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          onError={(e) => { e.target.src = FALLBACK; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-90" />
        <div className="absolute top-4 left-4 flex gap-2">
          <span className="px-3 py-1 text-[10px] font-bold uppercase tracking-widest bg-white text-black">
            2. El Araç
          </span>
          {car.is_featured && (
            <span className="px-3 py-1 text-[10px] font-bold uppercase tracking-widest bg-black border border-orange-600 text-orange-500">
              Öne Çıkan
            </span>
          )}
        </div>
        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex items-end justify-between">
            <div>
              <p className="text-xs uppercase tracking-widest text-orange-500 font-bold">
                {car.brand}
              </p>
              <h3 className="font-display text-2xl font-bold uppercase text-white leading-tight mt-1">
                {car.model}
              </h3>
            </div>
            <div className="w-10 h-10 bg-orange-600 group-hover:bg-white group-hover:text-black flex items-center justify-center transition-colors">
              <ArrowUpRight size={20} className="text-white group-hover:text-black" />
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 border-t border-zinc-900">
        <div className="flex items-center gap-3 text-xs text-zinc-400 flex-wrap mb-3">
          <span className="flex items-center gap-1.5">
            <Calendar size={14} className="text-orange-500" /> {car.year}
          </span>
          {car.mileage != null && (
            <span className="flex items-center gap-1.5">
              <Gauge size={14} className="text-orange-500" /> {car.mileage.toLocaleString("tr-TR")} km
            </span>
          )}
          {car.fuel_type && (
            <span className="flex items-center gap-1.5">
              <Fuel size={14} className="text-orange-500" /> {car.fuel_type}
            </span>
          )}
          {car.transmission && (
            <span className="flex items-center gap-1.5">
              <Cog size={14} className="text-orange-500" /> {car.transmission}
            </span>
          )}
        </div>
        <p className="font-display text-lg font-bold text-white">
          {formatPrice(car.price)}
        </p>
      </div>
    </Link>
  );
};

export default CarCard;
